import { ValueType } from "../../../Definitions";

/* eslint-disable */
export enum UndefinedOptions {
  undefined = "undefined",
  nan = "NaN",
  null = "null"
}
/* eslint-enable */

export type SelectOptions = {
  feedcurveOptions: ValueType[];
  groupOptions: ValueType[];
  systemOptions: ValueType[];
  milestoneOptions: ValueType[];
  locationOptions: ValueType[];
  sectionOptions: ValueType[];
  animalOptions: ValueType[];
  allSectionOptions: ValueType[];
  milestoneOptionsFromFeedcurve: ValueType[] | undefined;
}

export { useFeedcurveOptions } from "./useFeedcurveOptions"
export { useGroupOptions } from "./useGroupOptions"
export { useMilestoneOptions } from "./useMilestoneOptions"
export { useSystemOptions } from "./useSystemOptions"
export { useAnimalOptions } from "./useAnimalOptions"
export { useSectionOptions } from "./useSectionOptions"